export default __webpack_public_path__ + "static/media/ico_header_logo.c56a07d5.svg";